import { digitChanger, monthChanger } from "helpers/helper";
import moment from "moment";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import parse from "html-react-parser";

export default function ArticleCard({ data }) {
	const ekkLanguage = useSelector((state) => state.lan.lan);
	const [showFullContent, setShowFullContent] = useState(false);

	// Parse the HTML content
	const parsedContent = parse(data.message);

	// Convert to plain text for length calculation
	const contentText =
		typeof data.message === "string"
			? data.message.replace(/<[^>]*>/g, "")
			: "";

	const displayContent = showFullContent
		? parsedContent
		: contentText.length > 180
		? parse(data.message.substring(0, 180))
		: parsedContent;

	return (
		<div
			className='px-3 py-3 mb-1 bg-white '
			style={{
				borderRadius: "15px 15px 15px 15px",
				boxShadow: "rgba(0, 0, 0, 0.14) 0px 1px 10px 0px",
			}}>
			<div className='py-3 bg-white px-4 mb-[6px]'>
				{/* Image Section  */}
				{data?.imageUrl?.length > 0 && (
					<div className='rounded-[8px] mb-[10px]'>
						<img
							src={data?.imageUrl[0]}
							className='w-full'
							alt='slideImage'
						/>
					</div>
				)}
				{/* Title  */}
				<h6 className='font-bold text-16 mb-[5px]'>
					{data.title}
					{data?.tags?.length > 4 && <br />}
					{data.tags &&
						data.tags.length > 0 &&
						data.tags.map((tag, index) => {
							return (
								<span key={index} className='text-delivered px-0.5'>
									#{tag}
								</span>
							);
						})}
				</h6>
				{/* Created Date  */}
				<span className='text-808080 font-semibold text-12'>
					{digitChanger(
						monthChanger(moment(data.createdAt).format("DD MMM, YY"))
					)}
				</span>
				{/* Content  */}
				<p className='text-14 font-medium text-222222 text-justify'>
					{displayContent}
					{contentText.length > 180 && !showFullContent && (
						<span
							className='text-delivered cursor-pointer ml-1'
							onClick={() => setShowFullContent(true)}>
							{ekkLanguage.landing.seeMore}
						</span>
					)}
				</p>
			</div>
		</div>
	);
}
